import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ANIMATIONS = {
  first_conversation: { emoji: '&#127881;', title: 'First Conversation!', subtitle: 'You did it! Your first conversation is in the books.', color: '#8B5CF6' },
  ten_conversations: { emoji: '&#128293;', title: '10 Conversations!', subtitle: "You're on a roll! Ten conversations and counting.", color: '#F59E0B' },
  hundred_hearts: { emoji: '&#10084;&#65039;', title: '100 Hearts!', subtitle: "A hundred hearts earned. You're making real connections.", color: '#EF4444' },
  first_badge: { emoji: '&#127941;', title: 'First Badge Earned!', subtitle: 'Your first badge! This is just the beginning.', color: '#10B981' },
  all_foundation: { emoji: '&#127942;', title: 'Foundation Complete!', subtitle: "All Foundation badges earned. You've built a solid base.", color: '#6366F1' },
  first_streak_week: { emoji: '&#128170;', title: '7-Day Streak!', subtitle: 'A full week of showing up. Consistency builds confidence.', color: '#F97316' },
  thirty_day_streak: { emoji: '&#9889;', title: '30-Day Streak!', subtitle: 'Thirty days straight. Unstoppable.', color: '#EAB308' },
  first_nft: { emoji: '&#128142;', title: 'First NFT Minted!', subtitle: 'Your first NFT is on the blockchain. Truly yours.', color: '#EC4899' },
};

const MilestoneCelebration = () => {
  const [celebration, setCelebration] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    fetch(`${API_URL}/api/engagement/milestones`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => {
        if (data.unseen_celebrations && data.unseen_celebrations.length > 0) {
          const first = data.unseen_celebrations[0];
          const anim = ANIMATIONS[first.milestone_type];
          if (anim) {
            setCelebration({ ...anim, type: first.milestone_type });
            setTimeout(() => setVisible(true), 500);
          }
        }
      }).catch(() => {});
  }, []);

  const dismiss = async () => {
    setVisible(false);
    if (celebration) {
      const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
      fetch(`${API_URL}/api/engagement/milestones/${celebration.type}/seen`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {});
    }
    setTimeout(() => setCelebration(null), 500);
  };

  if (!celebration) return null;

  return (
    <div className={`fixed inset-0 z-[9998] flex items-center justify-center px-4 py-8 overflow-y-auto transition-opacity duration-500 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-testid="milestone-celebration">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative z-10 bg-white rounded-2xl p-5 sm:p-7 max-w-sm w-full max-h-[90vh] overflow-y-auto text-center shadow-2xl">
        <button onClick={dismiss} className="absolute top-3 right-3 p-1 rounded-full hover:bg-gray-100"><X size={18} className="text-gray-400" /></button>
        <div className="text-5xl mb-4" dangerouslySetInnerHTML={{ __html: celebration.emoji }} />
        <h2 className="text-xl font-bold mb-2" style={{ color: celebration.color }}>{celebration.title}</h2>
        <p className="text-sm text-gray-600">{celebration.subtitle}</p>
        <button onClick={dismiss} className="mt-6 px-6 py-2.5 rounded-xl text-white text-sm font-semibold" style={{ backgroundColor: celebration.color }}>
          Keep Going
        </button>
      </div>
    </div>
  );
};

export default MilestoneCelebration;
